import ClientAgent from '../clientAgent'

export class SharedPermissionHelper {
  static instance = null
  _sharedPermissionsWithMe = null
  _sharedPermissionsByMe = null
  _ca = null

  /**
   * @returns {SharedPermissionHelper}
   */
  static getInstance () {
    if (this.instance === null) {
      this.instance = new this()
    }
    return this.instance
  }

  async loadList (sharedWithMe = false, override = false) {
    if (
      override === true ||
      (
        this._sharedPermissionsWithMe === null && sharedWithMe ||
        this._sharedPermissionsByMe === null && !sharedWithMe
      )
    ) {
      let apiUrl = 'permissions/getAllSharedPermissions?'
      if (sharedWithMe === true) {
        apiUrl = 'permissions/getAllPermissionsSharedWithMe?'
      }
      let response = await this.ca.makeRequest(apiUrl, {}, 'POST')
      if (sharedWithMe) {
        this._sharedPermissionsWithMe = response.data
      } else {
        this._sharedPermissionsByMe = response.data
      }
    }
  }

  hasPendingSharedPermissionRequest (permission) {
    if (this._sharedPermissionsWithMe === null) {
      throw new Error('Napaka pri pridobivanju seznama deljenih pravic')
    }
    let out = false
    this._sharedPermissionsWithMe.pending.forEach((pendingItem) => {
      pendingItem.dovoljenja.forEach((item) => {
        if (item.permission === permission) {
          out = true
        }
      })
    })

    return out
  }

  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Permissions/SharedPermissionHelper.js